export const DEFAULT_AUTOFIX_TEMPLATE = `Build failed. Please investigate and fix the issue.

App: {{app_name}}
Project: {{project_path}}
Ref: {{ref}}
Job: {{job_name}} (id {{job_id}})
Job URL: {{job_url}}

{{job_log}}`;

export const TOOL_SCOPES = [
  { value: 'logs:read', label: 'Raw logs', kind: 'read' },
  { value: 'logs:query', label: 'Structured log query', kind: 'read' },
  { value: 'logs:detail', label: 'Structured log detail', kind: 'read' },
  { value: 'pipelines:read', label: 'Pipeline list', kind: 'read' },
  { value: 'pipelines:jobs:read', label: 'Pipeline jobs', kind: 'read' },
  { value: 'pipelines:logs:read', label: 'Pipeline job logs', kind: 'read' },
  { value: 'pipelines:artifacts:read', label: 'Pipeline job artifact files', kind: 'read' },
  { value: 'pipelines:play', label: 'Play manual job', kind: 'action' },
  { value: 'pipelines:play:*', label: 'Deploy stages', kind: 'action' },
  { value: 'context:read', label: 'Conversation context', kind: 'read' },
  { value: 'activities:read', label: 'Turn activities', kind: 'read' },
  { value: 'ui-validation:read', label: 'Managed UI validation', kind: 'read' },
  { value: 'ui-validation:run', label: 'Run managed UI validation', kind: 'action' },
  { value: 'tool-settings:read', label: 'Tool settings', kind: 'read' },
  { value: 'tool-settings:write', label: 'Edit tool settings', kind: 'action' },
  { value: 'merge_requests:write', label: 'Merge requests', kind: 'action' },
  { value: 'conversations:create', label: 'Create conversations', kind: 'action' },
  { value: 'conversations:messages:write', label: 'Send conversation messages', kind: 'action' },
  { value: 'attachments:write', label: 'Attach files', kind: 'read' },
  { value: 'sessions:register', label: 'Local CLI sessions', kind: 'read' }
];

export const DEFAULT_TOOL_SCOPES = TOOL_SCOPES.filter((scope) => scope.kind === 'read').map(
  (scope) => scope.value
);
